export const retryMutation = async (mutation: any, input: any, maxRetries = 2) => {
  let lastError;
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await mutation.mutateAsync(input);
    } catch (error) {
      lastError = error;
      if (i < maxRetries - 1) {
        // Wait for 500ms before retrying
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
    }
  }
  throw lastError;
};
